import { request } from "services/api/util";

class TopSpenderCampaignService {
  async getListTopSpenderCampaign(params) {
    const config = {
      method: "get",
      url: `admin/topSpenderCampaign`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailTopSpenderCampaign(id) {
    const config = {
      method: "get",
      url: `admin/topSpenderCampaign/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createTopSpenderCampaign(body) {
    const config = {
      method: "post",
      url: `admin/topSpenderCampaign`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async updateTopSpenderCampaign(body, id) {
    const config = {
      method: "put",
      url: `admin/topSpenderCampaign/${id}`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getListFormTypes() {
    const config = {
      method: "get",
      url: `admin/topSpenderCampaign/formTypes`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async downloadCampaignParticipants(id) {
    const config = {
      method: "get",
      url: `admin/topSpenderCampaign/export/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new TopSpenderCampaignService();
